const JST_TIME_ZONE = 'Asia/Tokyo';

const getJstDateParts = (date = new Date()) => {
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: JST_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

  const parts = formatter.formatToParts(date);
  const year = parts.find((p) => p.type === 'year')?.value;
  const month = parts.find((p) => p.type === 'month')?.value;
  const day = parts.find((p) => p.type === 'day')?.value;
  return { year, month, day };
};

export const toJstDateInputValue = (date = new Date()) => {
  const { year, month, day } = getJstDateParts(date);
  return `${year}-${month}-${day}`;
};

// 端末タイムゾーンに依存せず、Dateのローカル表示は常にJSTに統一する。
export const ensureJstDateLocale = () => {
  const patchFlag = '__medichatJstDateLocalePatched__';
  if (Date.prototype[patchFlag]) return;

  const patchMethod = (methodName) => {
    const original = Date.prototype[methodName];
    Object.defineProperty(Date.prototype, methodName, {
      configurable: true,
      writable: true,
      value(locales, options) {
        const withLocale = locales ?? 'ja-JP';
        const withTimeZone = options?.timeZone ? options : { ...(options || {}), timeZone: JST_TIME_ZONE };
        return original.call(this, withLocale, withTimeZone);
      },
    });
  };

  patchMethod('toLocaleString');
  patchMethod('toLocaleDateString');
  patchMethod('toLocaleTimeString');

  Object.defineProperty(Date.prototype, patchFlag, {
    value: true,
    enumerable: false,
    configurable: false,
  });
};
